import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import getMonthForRender from './Month';
import { MonthSelector } from './MonthSelector';
import RenderDays from './RenderDays';
import { getWeekDays } from './utils';
export default function Calendar({ value = undefined, isWeekDays = false, isShowToday = false, isMonthsSelector = false, currentMonth = undefined, activeDates = undefined, onDateSelect, t, className }) {
    const [currValue] = React.useState(value);
    const [currPosition, setCurrPosition] = useState(currentMonth ? dayjs().month(currentMonth) : (currValue ? dayjs(currValue) : dayjs()));
    const [daysForRender, setDaysForRender] = useState(getMonthForRender(currPosition.toString()));
    const weekDays = getWeekDays(t);
    useEffect(() => {
        setDaysForRender(getMonthForRender(currPosition.toString()));
    }, [currPosition]);
    const changeMonth = (direction) => {
        const dir = direction === 'back' ? -1 : 1;
        setCurrPosition(currPosition.month(currPosition.month() + dir));
    };
    const onSubmit = (day) => {
        onDateSelect(day.date);
    };
    const onSelect = (day, isActive) => {
        if (!isActive)
            return;
        onSubmit(day);
    };
    return (_jsxs(Container, { className: className, children: [isMonthsSelector && _jsx(MonthSelector, { year: currPosition.year(), month: currPosition.month(), onMonthChange: changeMonth, t: t }), _jsx(DaysHeader, { children: isWeekDays && weekDays.map((name, index) => {
                    return _jsx("span", { className: 'week-day', children: name }, index);
                }) }), _jsxs(Content, { children: [_jsx(RenderDays, { daysForRender: daysForRender.prevMonth, activeDates: activeDates, onSelect: () => changeMonth('back'), curValue: currValue, isShowToday: isShowToday, isDisabled: true }), _jsx(RenderDays, { daysForRender: daysForRender.currentMonth, activeDates: activeDates, currPosition: currPosition, onSelect: onSelect, curValue: currValue, isShowToday: isShowToday, isCurrentMonth: true }), _jsx(RenderDays, { daysForRender: daysForRender.nextMonth, activeDates: activeDates, onSelect: () => changeMonth('forward'), curValue: currValue, isShowToday: isShowToday, isDisabled: true })] })] }));
}
const Container = styled.div `
  box-sizing: border-box;
  color: var(--text-primary);
  padding: 1rem;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--ui-popup-bg);
`;
const DaysHeader = styled.div `
  width: 100%;
  font-size: 0.875rem;
  display: grid;
  grid-gap: 0.75rem;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  margin-bottom: 1rem;
  overflow: hidden;
  user-select: none;

  & .week-day {
    text-align: center;
  }
`;
const Content = styled.div `
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(auto-fill, minmax(1.5rem, 1fr));
  grid-gap: 0.75rem;
  align-items: center;
  justify-content: center;
`;
